import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { AIGuideTab } from "../components/ai/AIGuideTab";
import { useAuth } from "../contexts/AuthContext";

/**
 * «Guida AI»: cosa si può chiedere all'assistente. Guscio: autenticazione e
 * Layout; il resto sta in `AIGuideTab`.
 */
export default function AIGuide() {
	const { user } = useAuth();
	const isCoach = user?.role === "coach" || user?.is_admin;

	if (!isCoach) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout>
			<AIGuideTab />
		</Layout>
	);
}
